import classNames from "classnames";
import { KeyboardEvent } from "react";

interface IInteractiveBlockProps {
  onClick?: () => void;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
  className?: string;
  children: React.ReactNode;
  boxShadow?: boolean;
  asLink?: boolean;
  tabIndex?: number;
  disabled?: boolean;
}
export function InteractiveBlock(props: Readonly<IInteractiveBlockProps>) {
  const {
    children,
    className,
    boxShadow,
    asLink,
    tabIndex,
    onClick,
    onKeyDown,
    disabled,
  } = props;

  const classNameBoxShadow = boxShadow ? "intaractive-box-shadow" : "";
  const classNameLink = asLink ? "interactive-link" : "";
  const classNameBlock = classNames(
    "interactive-block",
    classNameBoxShadow,
    classNameLink,
    className,
  );

  return (
    <button
      className={classNameBlock}
      onClick={onClick}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
